// @core/api/endpoints/apikey/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { ActivateAPIKey } from './activate_api_key';
import { CreateAPIKey } from './create_api_key';
import { CreateAPIKeyPolicy } from './create_api_key_policy';
import { DeleteAPIKey } from './delete_api_key';
import { DeleteAPIKeyPolicy } from './delete_api_key_policy';
import { GetAPIKey } from './get_api_key';
import { GetAPIKeyAuditLogs } from './get_api_key_audit_logs';
import { GetAPIKeyPolicy } from './get_api_key_policy';
import { GetAPIKeyPolicyByEntity } from './get_api_key_policy_by_entity';
import { GetAPIKeyUsage } from './get_api_key_usage';
import { GetAPIKeyUsageHistory } from './get_api_key_usage_history';
import { ListAPIKeyPolicies } from './list_api_key_policies';
import { ListAPIKeys } from './list_api_keys';
import { ListPermissions } from './list_permissions';
import { ListScopes } from './list_scopes';
import { RecordAPIKeyUsage } from './record_api_key_usage';
import { RegenerateAPIKey } from './regenerate_api_key';
import { ResolveAPIKeyContext } from './resolve_api_key_context';
import { RevokeAPIKey } from './revoke_api_key';
import { SuspendAPIKey } from './suspend_api_key';
import { UpdateAPIKey } from './update_api_key';
import { UpdateAPIKeyPolicy } from './update_api_key_policy';
import { ValidateAPIKey } from './validate_api_key';

// Re-export individual endpoints
export {
  ActivateAPIKey,
  CreateAPIKey,
  CreateAPIKeyPolicy,
  DeleteAPIKey,
  DeleteAPIKeyPolicy,
  GetAPIKey,
  GetAPIKeyAuditLogs,
  GetAPIKeyPolicy,
  GetAPIKeyPolicyByEntity,
  GetAPIKeyUsage,
  GetAPIKeyUsageHistory,
  ListAPIKeyPolicies,
  ListAPIKeys,
  ListPermissions,
  ListScopes,
  RecordAPIKeyUsage,
  RegenerateAPIKey,
  ResolveAPIKeyContext,
  RevokeAPIKey,
  SuspendAPIKey,
  UpdateAPIKey,
  UpdateAPIKeyPolicy,
  ValidateAPIKey,
};

// Namespace export for convenient usage
export const apikeyApi = {
  ActivateAPIKey,
  CreateAPIKey,
  CreateAPIKeyPolicy,
  DeleteAPIKey,
  DeleteAPIKeyPolicy,
  GetAPIKey,
  GetAPIKeyAuditLogs,
  GetAPIKeyPolicy,
  GetAPIKeyPolicyByEntity,
  GetAPIKeyUsage,
  GetAPIKeyUsageHistory,
  ListAPIKeyPolicies,
  ListAPIKeys,
  ListPermissions,
  ListScopes,
  RecordAPIKeyUsage,
  RegenerateAPIKey,
  ResolveAPIKeyContext,
  RevokeAPIKey,
  SuspendAPIKey,
  UpdateAPIKey,
  UpdateAPIKeyPolicy,
  ValidateAPIKey,
};
